import { AppBreadcrumbsBuilder } from "@/lib/breadcrumbs";
import type { IBreadcrumbItem } from "@cmde/shadcn";
import { RoutePaths } from "@/config/route-paths";
import i18next from "i18next";

export const getCustomerListBreadcrumbs = (): IBreadcrumbItem[] => {
  return AppBreadcrumbsBuilder.start()
    .withSportradar()
    .withStatsAdmin()
    .withBreadcrumb({
      title: i18next.t("customers.list.breadcrumbs.customers"),
      href: RoutePaths.customers.list(),
    })
    .build();
};
